import moment from "moment"

const COLUMNS = [
    {
        Header: '#',
        accessor: 'id',
    },
    {
        Header: 'Name',
        accessor: 'name',
    },
    {
        Header: 'Username',
        accessor: 'username',
    },
    {
        Header: 'Phone Number',
        accessor: 'contact_no',
    },
    {
        Header: 'Gender',
        accessor: 'gender',
    },
    {
        Header: 'Partner',
        accessor: 'partnerUsers[0].partner.name'
    },
    {
        Header: 'Age',
        accessor: 'dob',
        Cell: ({ value }) => {
            return moment().diff(moment(value), 'years')
        }
    },
    {
        Header: 'Inventory ID',
        accessor: 'inventoryId',
    },

]

export { COLUMNS }